const Phone = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5 6.5A2.5 2.5 0 0 1 9 4h6a2.5 2.5 0 0 1 2.5 2.5v11A2.5 2.5 0 0 1 15 20H9a2.5 2.5 0 0 1-2.5-2.5zM9 5a1.5 1.5 0 0 0-1.5 1.5v11A1.5 1.5 0 0 0 9 19h6a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 15 5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M9.5 16.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
    />
  </>
)
export default Phone
